<template>
  <Head title="Tambah Widget Baru" />
  <div>
    <h1 class="mb-6 text-2xl font-bold">Tambah Widget Baru</h1>

    <div class="mb-6">
      <Link
        :href="route('widgets.index')"
        class="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
      >
        Kembali
      </Link>
    </div>

    <form
      @submit.prevent="form.post(route('widgets.store'))"
      class="max-w-lg p-6 bg-white rounded-lg shadow-md"
    >
      <div class="mb-4">
        <label for="name" class="block mb-2 text-sm font-medium text-gray-700"
          >Nama Widget</label
        >
        <input
          id="name"
          v-model="form.name"
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
          required
        />
        <div v-if="form.errors.name" class="mt-1 text-sm text-red-600">
          {{ form.errors.name }}
        </div>
      </div>

      <div class="mb-4">
        <label
          for="component"
          class="block mb-2 text-sm font-medium text-gray-700"
          >Komponen</label
        >
        <select
          id="component"
          v-model="form.component"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
          required
        >
          <option value="">Pilih Komponen</option>
          <option
            v-for="(path, name) in availableComponents"
            :key="name"
            :value="path"
          >
            {{ name }}
          </option>
        </select>
        <div v-if="form.errors.component" class="mt-1 text-sm text-red-600">
          {{ form.errors.component }}
        </div>
      </div>

      <div class="mb-4">
        <label
          for="description"
          class="block mb-2 text-sm font-medium text-gray-700"
          >Deskripsi</label
        >
        <textarea
          id="description"
          v-model="form.description"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
          rows="3"
        ></textarea>
        <div v-if="form.errors.description" class="mt-1 text-sm text-red-600">
          {{ form.errors.description }}
        </div>
      </div>

      <div class="mb-4">
        <label for="order" class="block mb-2 text-sm font-medium text-gray-700"
          >Urutan</label
        >
        <input
          id="order"
          v-model="form.order"
          type="number"
          min="0"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
        />
        <div v-if="form.errors.order" class="mt-1 text-sm text-red-600">
          {{ form.errors.order }}
        </div>
      </div>

      <div class="mb-4">
        <label class="flex items-center">
          <input
            type="checkbox"
            v-model="form.is_active"
            class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <span class="ml-2 text-sm text-gray-700">Aktif</span>
        </label>
      </div>

      <div>
        <button
          type="submit"
          class="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          :disabled="form.processing"
        >
          Simpan
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { Head, Link, useForm } from "@inertiajs/vue3";
const route = inject('route');

const props = defineProps({
  availableComponents: Object,
});

const form = useForm({
  name: "",
  component: "",
  description: "",
  order: 0,
  is_active: true,
  config: {},
});
</script>
